import axiosInstance from './axiosInstance';

const base = '/maylawan';

const list = async ({ search = '', page = 1, limit = 20 } = {}) => {
  const { data } = await axiosInstance.get(`${base}/admin/list`, { params: { search, page, limit } });
  return data;
};

const create = async ({ email, password, sendWelcomeEmail = false }) => {
  const { data } = await axiosInstance.post(`${base}/admin/create`, { email, password, sendWelcomeEmail });
  return data;
};

const update = async (id, { email, password }) => {
  const { data } = await axiosInstance.put(`${base}/admin/update/${id}`, { email, password });
  return data;
};

const remove = async (id) => {
  const { data } = await axiosInstance.delete(`${base}/admin/delete/${id}`);
  return data;
};

const resetDevice = async (id) => {
  const { data } = await axiosInstance.post(`${base}/admin/reset-device/${id}`);
  return data;
};

const sendEmail = async (id, payload) => {
  const { data } = await axiosInstance.post(`${base}/admin/send-email/${id}`, payload);
  return data;
};

export default { list, create, update, remove, resetDevice, sendEmail };


